module.exports = __webpack_public_path__ + "img/behold-9.6206734b.png";